module.exports = __webpack_public_path__ + "images/5ff109df.h5_img_chs_win_4.png";


//////////////////
// WEBPACK FOOTER
// ./images/h5_img_chs_win_4.png
// module id = 339
// module chunks = 0